 const grade_3= {
    label: "Grade 3",
    subjects: {
        applied_design_3: {
  label: "Applied Design ( Grade k-3)",
  topics: [
    // { value: "defining", label: "Defining" },
    { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
  ],
  competencies: {
    core: [
       { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
    ],
   sub: {
      applied_design: [
        // Defining
        {
          value: "identify_needs_opportunities",
          label: "Identify needs and opportunities for designing, through exploration"
        },

        // Ideating
        {
          value: "generate_ideas",
          label: "Generate ideas from their experiences and interests"
        },
        {
          value: "add_to_others_ideas",
          label: "Add to others’ ideas"
        },
        {
          value: "choose_idea",
          label: "Choose an idea to pursue"
        },

        // Prototyping
        {
          value: "choose_tools_materials",
          label: "Choose tools and materials"
        },
        {
          value: "make_product",
          label: "Make a product using known procedures or through modelling of others"
        },

        // Testing
        {
          value: "trial_and_error",
          label: "Use trial and error to make changes, solve problems, or incorporate new ideas from self or others"
        },

        // Making
        {
          value: "decide_sharing",
          label: "Decide on how and with whom to share their product"
        },

        // Sharing
        {
          value: "demonstrate_product",
          label: "Demonstrate their product, tell the story of designing and making their product, and explain how their product contributes to the individual, family, community, and/or environment"
        },
        {
          value: "evaluate_design_solution",
          label: "Use personal preferences to evaluate the success of their design solutions"
        },
        {
          value: "reflect_on_ability",
          label: "Reflect on their ability to work effectively both as individuals and collaboratively in a group"
        }
      ],

      applied_skills: [
        {
          value: "safe_use_tools",
          label: "Use materials, tools, and technologies in a safe manner in both physical and digital environments"
        },
        {
          value: "develop_skills_play",
          label: "Develop their skills and add new ones through play and collaborative work"
        }
      ],

      applied_technologies: [
        {
          value: "explore_simple_tools",
          label: "Explore the use of simple, available tools and technologies to extend their capabilities"
        }
      ]
    }
  }
},
  
  "arts_3": {
    "label": "Arts Education (Grade 3)",
    topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],
      "sub": {
        "exploring_creating": [
          {
            "value": "choose_elements_processes",
            "label": "Choose elements, processes, materials, movements, technologies, tools, techniques, and environments of the arts"
          },
          {
            "value": "create_artistic_works_collab_individual",
            "label": "Create artistic works collaboratively and as an individual, using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_belonging",
            "label": "Explore identity, place, culture, and belonging through arts experiences"
          },
          {
            "value": "explore_relationships_cultures_arts",
            "label": "Explore relationships among cultures, communities, and the arts"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "observe_listen_predict_artist_use",
            "label": "Observe, listen, describe, inquire, and predict how artists use processes, materials, movements, technologies, tools, and techniques"
          },
          {
            "value": "refine_ideas_processes_skills",
            "label": "Refine ideas, processes, and technical skills in a variety of art forms"
          },
          {
            "value": "reflect_connect_personal_experiences",
            "label": "Reflect on creative processes and make connections to personal experiences"
          },
          {
            "value": "connect_skills_other_learning",
            "label": "Connect knowledge and skills from other areas of learning in planning, creating, and interpreting works of art"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbolism",
            "label": "Interpret and communicate ideas using symbolism in the arts"
          },
          {
            "value": "express_feelings_creative_ways",
            "label": "Express feelings, ideas, and experiences in creative ways"
          },
          {
            "value": "describe_respond_feedback",
            "label": "Describe and respond to visual and performing art pieces and provide constructive feedback"
          }
        ],

        "connecting_expanding": [
          {
            "value": "experience_document_share",
            "label": "Experience, document, and share creative works in a variety of ways"
          },
          {
            "value": "apply_skills_new_contexts",
            "label": "Apply learned skills, understandings, and processes in new contexts"
          },
          {
            "value": "demonstrate_sophisticated_application",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  }
,  
 career_education_3: {
        label: 'Career Education (Grade 3)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments' },
              { value: 'demonstrate_effective_work_habits', label: 'Demonstrate effective work habits and organizational skills appropriate to their level of development' }
            ],
            interact: [
              { value: 'work_respectfully_and_constructively', label: 'Work respectfully and constructively with others to achieve common goals' },
              { value: 'identify_and_appreciate_roles_and_responsibilities', label: 'Identify and appreciate the roles and responsibilities of people in their schools, families, and communities' },
              { value: 'recognize_the_importance_of_positive_relationships', label: 'Recognize the importance of positive relationships in their lives' }
            ],
            experience: [
              { value: 'recognize_the_importance_of_learning', label: 'Recognize the importance of learning in their lives and future careers' }
            ],
            initiate: [
              { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals for themselves' }
            ],
            share: [
              { value: 'share_ideas_information_feelings_and_knowledge', label: 'Share ideas, information, personal feelings, and knowledge with others' },
              { value: 'recognize_the_basic_skills_required', label: 'Recognize the basic skills required in a variety of jobs in the community' }
            ]
          }
        }
      },

  "english_3": {
    "label": "English Language Arts (Grade 3)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "read_fluently_grade_level",
            "label": "Read fluently at grade level (Grade 1–3)"
          },
          {
            "value": "use_sources_prior_knowledge",
            "label": "Use sources of information and prior knowledge to make meaning (K-3)"
          },
          {
            "value": "make_connections_variety_sources",
            "label": "Make connections between ideas from a variety of sources and prior knowledge to build understanding"
          },
          {
            "value": "use_read_listen_view_strategies",
            "label": "Use developmentally appropriate reading, listening, and viewing strategies to make meaning (K-3)"
          },
          {
            "value": "recognize_texts_purposes",
            "label": "Recognize how different texts reflect different purposes"
          },
          {
            "value": "engage_actively",
            "label": "Engage actively as listeners, viewers, and readers to develop understanding of self, identity, and community (K-3)"
          },
          {
            "value": "explain_role_story_identity",
            "label": "Explain the role that story plays in personal, family, and community identity"
          },
          {
            "value": "use_personal_experience_make_meaning",
            "label": "Use personal experience and knowledge to connect to text and make meaning"
          },
          {
            "value": "recognize_structure_elements_story",
            "label": "Recognize the structure and elements of story (Grade 1–3)"
          },
          {
            "value": "awareness_fp_story_connections",
            "label": "Show awareness of how story in First Peoples cultures connects people to family and community (Grade 1–3)"
          },
          {
            "value": "awareness_fp_story_land",
            "label": "Develop awareness of how story in First Peoples cultures connects people to land"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "create_stories_texts_awareness",
            "label": "Create stories and other texts to deepen awareness of self, family, and community (K-3)"
          },
          {
            "value": "plan_create_variety_forms",
            "label": "Plan and create a variety of communication forms for different purposes and audiences (Grade 1–3)"
          },
          {
            "value": "communicate_using_conventions",
            "label": "Communicate using sentences and most conventions of Canadian spelling, grammar, and punctuation (Grade 2–3)"
          },
          {
            "value": "develop_apply_word_knowledge",
            "label": "Develop and apply expanding word knowledge (Grade 3–5)"
          },
          {
            "value": "explore_appreciate_fp_oral_traditions",
            "label": "Explore and appreciate aspects of First Peoples oral traditions"
          },
          {
            "value": "use_oral_storytelling_processes",
            "label": "Use oral storytelling processes (Grade 3–5)"
          }
        ]
      }
    }
  }

,


  "math_3": {
    "label": "Mathematics (Grade 3)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  },
     
      "phe_3": {
    "label": "Physical and Health Education (Grade 3)",
   "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "fundamental_movement_skills_3",
            "label": "Develop and apply fundamental movement skills in a variety of activities (3–5)"
          },
          {
            "value": "apply_movement_concepts_3",
            "label": "Apply movement concepts and strategies in different physical activities (3–4)"
          },
          {
            "value": "monitor_exertion_methods_3",
            "label": "Apply methods of monitoring exertion (2–4)"
          },
          {
            "value": "safety_fair_play_leadership_3",
            "label": "Develop and demonstrate safety, fair play, and leadership (K–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "opportunities_challenges_activity_3",
            "label": "Identify and describe opportunities and challenges for being active"
          },
          {
            "value": "healthy_eating_strategies_3",
            "label": "Explore strategies for making healthy eating choices"
          },
          {
            "value": "access_health_info_3",
            "label": "Access information and support for various health topics (2–3)"
          },
          {
            "value": "personal_healthy_living_goals_3",
            "label": "Explore and describe strategies for pursuing personal healthy-living goals"
          }
        ],

        "social_community_health": [
          {
            "value": "avoidance_assertiveness_3",
            "label": "Identify and use avoidance/assertiveness strategies (2–4)"
          },
          {
            "value": "positive_relationships_3",
            "label": "Develop strategies for positive relationships (3–4)"
          },
          {
            "value": "outdoor_activities_connection_3",
            "label": "Explain how outdoor activities support connection with community/environment (2–3)"
          }
        ],

        "mental_well_being": [
          {
            "value": "promote_mental_well_being_3",
            "label": "Identify and apply strategies that promote mental well-being (2–3)"
          },
          {
            "value": "describe_changes_3",
            "label": "Describe physical, emotional, and social changes as students grow older"
          },
          {
            "value": "factors_influencing_well_being_self_identity_3",
            "label": "Describe factors influencing mental well-being and self-identity"
          }
        ]
      }
    }
  },
      science_3: {
        label: "Science (Grade 3)",
        topics: [
          { value: "ecosystems", label: "Ecosystems" },
          { value: "forces_motion", label: "Forces and Motion" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "curiosity_natural_world", label: "Demonstrate curiosity about the natural world" },
              { value: "observe_familiar", label: "Observe objects and events in familiar contexts" },
              { value: "identify_investigable_questions", label: "Identify questions about familiar objects and events that can be investigated scientifically" },
              { value: "predictions_prior_knowledge", label: "Make predictions based on prior knowledge" }
            ],

            planning_conducting: [
              { value: "suggest_plans", label: "Suggest ways to plan and conduct an inquiry to find answers" },
              { value: "ethical_responsibilities", label: "Consider ethical responsibilities when conducting experiments" },
              { value: "use_tools_safely", label: "Safely use appropriate tools to make observations and measurements, using digital technology where appropriate" }
            ],

            processing_analyzing: [
              { value: "observe_living_nonliving", label: "Make observations about living and non-living things in the local environment" },
              { value: "collect_simple_data", label: "Collect simple data" },
              { value: "interpret_environment", label: "Experience and interpret the local environment" },
              { value: "first_peoples_perspectives", label: "Identify First Peoples perspectives and knowledge as sources of information" },
              { value: "sort_classify_information", label: "Sort and classify data and information using drawings or provided tables" },
              { value: "represent_data", label: "Use tables, simple bar graphs, or other formats to represent data and show patterns" },
              { value: "compare_results", label: "Compare results with predictions" },
              { value: "make_simple_inferences", label: "Make simple inferences based on results and prior knowledge" }
            ],

            evaluating: [
              { value: "fair_test_reflection", label: "Reflect on whether an investigation was a fair test" },
              { value: "appreciate_evidence", label: "Demonstrate an understanding and appreciation of evidence" },
              { value: "environmental_implications", label: "Identify some simple environmental implications of actions" }
            ],

            applying_innovating: [
              { value: "care_self_others", label: "Contribute to care for self, others, school, and neighbourhood through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "represent_communicate", label: "Represent and communicate ideas and findings in a variety of ways, such as diagrams and simple reports, using digital technologies as appropriate" },
              { value: "express_reflect_place", label: "Express and reflect on personal or shared experiences of place" }
            ]
          }
        }
      }
      ,
     
     
  "social_studies_3": {
    "label": "Social Studies (Grade 3)",
    "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],

      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss3",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "explain_significance_ss3",
            "label": "Explain why people, events, or places are significant to various individuals and groups"
          }
        ],

        "evidence": [
          {
            "value": "ask_infer_conclude_ss3",
            "label": "Ask questions, make inferences, and draw conclusions about the content and features of different types of sources"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_explain_change_ss3",
            "label": "Sequence objects, images, or events, and explain why some aspects change and others stay the same"
          }
        ],

        "cause_consequence": [
          {
            "value": "recognize_cause_effect_ss3",
            "label": "Recognize causes and consequences of events, decisions, or developments"
          }
        ],

        "perspective": [
          {
            "value": "explain_perspectives_ss3",
            "label": "Explain why people’s beliefs, values, worldviews, experiences, and roles give them different perspectives on people, places, issues, or events"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_value_judgments_ss3",
            "label": "Make value judgments about events, decisions, or actions, and suggest lessons that can be learned"
          }
        ]
      }
    }
  },







    }
  };

  export default grade_3;